module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar image = (helpers.detectRenderedImage(model.image, model._image) || {}).rendered || {};\n%>\n<div>\n<div class=\"image\" style=\"background-image:url(<%- image.url %>)\"></div>\n<div class=\"content\">\n<div class=\"title\"><%- model.title %></div>\n<div class=\"description\"><%- model.description %></div>\n<div class=\"info\">\n<div class=\"address\"><%- model.address %></div>\n<div class=\"details\">\n<table>\n<tr>\n<td>Grundstücksfläche:</td>\n<td><%- model.grundflaeche %> m<sup>2</sup></td>\n</tr>\n<tr>\n<td>Mietrelevante Nutzfläche:</td>\n<td><%- model.mietrelevanteNutzflaeche %> m<sup>2</sup></td>\n</tr>\n<tr>\n<td>Gesamtnutzfläche*:</td>\n<td><%- model.gesamtNutzflaeche %> m<sup>2</sup></td>\n</tr>\n<tr>\n<td>Nettorrendite*:</td>\n<td><%- model.nettorrendite %> &percnt;</td>\n</tr>\n</table>\n</div>\n</div>\n</div>\n</div>"
  , __filename = "components/templates/investmentProperties/object.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var image = (helpers.detectRenderedImage(model.image, model._image) || {}).rendered || {};

    ; __line = 3
    ; __append("\n<div>\n<div class=\"image\" style=\"background-image:url(")
    ; __line = 5
    ; __append( image.url )
    ; __append(")\"></div>\n<div class=\"content\">\n<div class=\"title\">")
    ; __line = 7
    ; __append( model.title )
    ; __append("</div>\n<div class=\"description\">")
    ; __line = 8
    ; __append( model.description )
    ; __append("</div>\n<div class=\"info\">\n<div class=\"address\">")
    ; __line = 10
    ; __append( model.address )
    ; __append("</div>\n<div class=\"details\">\n<table>\n<tr>\n<td>Grundstücksfläche:</td>\n<td>")
    ; __line = 15
    ; __append( model.grundflaeche )
    ; __append(" m<sup>2</sup></td>\n</tr>\n<tr>\n<td>Mietrelevante Nutzfläche:</td>\n<td>")
    ; __line = 19
    ; __append( model.mietrelevanteNutzflaeche )
    ; __append(" m<sup>2</sup></td>\n</tr>\n<tr>\n<td>Gesamtnutzfläche*:</td>\n<td>")
    ; __line = 23
    ; __append( model.gesamtNutzflaeche )
    ; __append(" m<sup>2</sup></td>\n</tr>\n<tr>\n<td>Nettorrendite*:</td>\n<td>")
    ; __line = 27
    ; __append( model.nettorrendite )
    ; __append(" &percnt;</td>\n</tr>\n</table>\n</div>\n</div>\n</div>\n</div>")
    ; __line = 33
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/investmentProperties/object.ejs

}